/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    StorNextConnection,
    StorNextConnectionFromJSON,
    StorNextConnectionFromJSONTyped,
    StorNextConnectionToJSON,
} from './';

/**
 * 
 * @export
 * @interface StorNextConnections
 */
export interface StorNextConnections {
    /**
     * 
     * @type {Array<StorNextConnection>}
     * @memberof StorNextConnections
     */
    list: Array<StorNextConnection>;
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof StorNextConnections
     */
    normal: { [key: string]: string | undefined; };
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof StorNextConnections
     */
    proxy: { [key: string]: string | undefined; };
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof StorNextConnections
     */
    gateway: { [key: string]: string | undefined; };
}

export function StorNextConnectionsFromJSON(json: any): StorNextConnections {
    return StorNextConnectionsFromJSONTyped(json, false);
}

export function StorNextConnectionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): StorNextConnections {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(StorNextConnectionFromJSON)),
        'normal': json['normal'],
        'proxy': json['proxy'],
        'gateway': json['gateway'],
    };
}

export function StorNextConnectionsToJSON(value?: StorNextConnections | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(StorNextConnectionToJSON)),
        'normal': value.normal,
        'proxy': value.proxy,
        'gateway': value.gateway,
    };
}


